import React from 'react';
import { useTranslate } from '@tolgee/react';

interface BrandColorPickerProps {
  /** Current primary color value (e.g., '#FF0000') */
  primaryColor: string;
  /** Current secondary color value (e.g., '#00FF00') */
  secondaryColor: string;
  /** Handler to update the primary color in the parent component */
  handlePrimaryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  /** Handler to update the secondary color in the parent component */
  handleSecondaryChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const BrandColorPicker: React.FC<BrandColorPickerProps> = ({
  primaryColor,
  secondaryColor,
  handlePrimaryChange,
  handleSecondaryChange
}) => {
  const { t } = useTranslate();

  return (
    <div className="my-3">
      <h5>{t('lomavis.branding.colors')}</h5>
      <p className="text-muted">{t('lomavis.branding.colors_helper_text')}</p>

      <div className="row">
        {/* Primary Color Picker */}
        <div className="col-sm-6 mb-3">
          <label htmlFor="primaryColor" className="form-label">
            {t('lomavis.branding.primary_color')}
          </label>
          <div className="d-flex align-items-center">
            <input
              type="color"
              id="primaryColor"
              className="me-2"
              value={primaryColor || "#FFFFFF"}
              onChange={handlePrimaryChange}
              title={t('lomavis.branding.choose_primary_color')}
              style={{
                width: '30px',
                height: '30px',
                border: 'none',
                padding: 0,
                background: 'none',
                cursor: 'pointer'
              }}

            />
            <input
              type="text"
              className="form-control"
              value={primaryColor }
              onChange={handlePrimaryChange}
            />
          </div>
        </div>

        {/* Secondary Color Picker */}
        <div className="col-sm-6 mb-3">
          <label htmlFor="secondaryColor" className="form-label">
            {t('lomavis.branding.secondary_color')}
          </label>
          <div className="d-flex align-items-center">
            <input
              type="color"
              style={{
                width: '30px',
                height: '30px',
                border: 'none',
                padding: 0,
                background: 'none',
                cursor: 'pointer'
              }}

              id="secondaryColor"
              className="me-2"
              value={secondaryColor || "#FFFFFF"}
              onChange={handleSecondaryChange}
              title={t('lomavis.branding.choose_secondary_color')}
            />
            <input
              type="text"
              className="form-control"
              value={secondaryColor}
              
              onChange={handleSecondaryChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandColorPicker;
